import { render } from "./TouchIcon.vue?vue&type=template&id=41527507"
const script = {}

import exportComponent from "C:\\GitLabRunner\\builds\\ThRl3iSS9\\0\\clients\\safan-darley\\kiosk.safandarley.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__